/**
 * FleetManager V3 - Placeholder Page
 * Temporary placeholder for views not yet implemented
 */

import React from 'react';
import { Settings } from 'lucide-react';
import { Card } from '../components/shared/index.js';

export function PlaceholderPage({ viewId, title }) {
  return (
    <div className="p-4">
      <Card padding="p-8" className="text-center">
        <Settings size={24} className="text-slate-500 mx-auto mb-3" />
        <h2 className="text-lg font-semibold text-white mb-1">
          {title || viewId}
        </h2>
        <p className="text-sm text-slate-400">
          Vue adaptative en cours de développement
        </p>
        <p className="text-xs text-slate-500 mt-2">
          Module: {viewId}
        </p>
      </Card>
    </div>
  );
}

export default PlaceholderPage;
